customElements.define('sticky-product-form', class StickyProductForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.productForm = document.querySelector('.product-single__form');

        this.productStickyForm = document.querySelector('.product--sticky-form');
        this.productFormBounds = {};
        this.stickySubmitButton = this.productStickyForm.querySelector('.sticky-form__submit');

        this.onScrollHandler = this.onScroll.bind(this);
        this.onSubmitButtonHandler = this.onSubmitButtonHandler.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.stickySubmitButton.addEventListener('click', this.onSubmitButtonHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        this.stickySubmitButton.removeEventListener('click', this.onSubmitButtonHandler);
    }
    onSubmitButtonHandler(e) {
        e.preventDefault();
        e.stopPropagation();

        const submitBtn = this.productForm.querySelector('.add-to-cart') || this.productForm.querySelector('[type="submit"]');
        if (submitBtn) {
            submitBtn.click();
        } else {
            this.productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.productFormBounds = entries[0].isIntersecting;
        });
        observer.observe(this.productForm);
    }

    onScroll() {
        this.productFormBounds ? requestAnimationFrame(this.hide.bind(this)) : requestAnimationFrame(this.reveal.bind(this));
    }

    hide() {
        if (this.productStickyForm.classList.contains('product--sticky-form__active')) {
            this.productStickyForm.classList.remove('product--sticky-form__active');
            this.productStickyForm.classList.add('product--sticky-form__inactive');
        }
    }

    reveal() {
        if (this.productStickyForm.classList.contains('product--sticky-form__inactive')) {
            this.productStickyForm.classList.add('product--sticky-form__active');
            this.productStickyForm.classList.remove('product--sticky-form__inactive');
        }
    }
});